const MAX_STARS = 5; // Define the maximum number of stars

export { MAX_STARS };
